import React from "react";
import t from "../../../helpers/t";
import Biscuit from "../../../../utils/Biscuit";

const NewProductButton = (props) => {
  return (
    <>
      <a
        href="/products/add"
        id="inb-c-left-bar-add-contingent"
        className={"button beautify beautify-" + Biscuit.get("user.client_id")}
      >
        <i className="fi fi-page-add"></i>
        <span>{t("add_${a}", { a: t("product", null, "capital") })}</span>
      </a>
    </>
  );
};
export default NewProductButton;
